<div class="nsc-card-content {{ class }}"><ng-content></ng-content></div>
